var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"item":_vm.email,"dense":"","label":_vm.email,"multiple":"","disabled":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})}
var staticRenderFns = []

export { render, staticRenderFns }